import z from "zod";

const phasesErrorTypeValues = ["PHASE_CALCULATION_FAILED"] as const;
const phasesErrorTypeSchema = z.enum(phasesErrorTypeValues);
const PhasesErrorType = phasesErrorTypeSchema.enum;
type PhasesErrorType = z.infer<typeof phasesErrorTypeSchema>;

export type PhasesErrors = {
  errorType: typeof PhasesErrorType.PHASE_CALCULATION_FAILED;
  data: { projectId: number; category: string; availablePhases: readonly string[] };
};

export const phasesErrorDetails: Record<PhasesErrorType, { sentryDescription: string }> = {
  PHASE_CALCULATION_FAILED: {
    sentryDescription: "Failed to calculate project phase due to empty phase order generation",
  },
};
